import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { FormInputLabelWrapperStyled, FormInputLabelStyled, FormInputStyled, FormInputError } from './styled'

const FormInput = forwardRef(({ placeholder, label, type, name, onChange, value, error, fullWidth, marginVertical, autoComplete, margin, maxWidth, maxLength, pattern, keyboardType, returnKeyType }, ref) => {
  return (
    <FormInputLabelWrapperStyled
      error={error}
      fullWidth={fullWidth}
      margin={margin}
      maxWidth={maxWidth}
    >
      {label && <FormInputLabelStyled>{label}</FormInputLabelStyled>}
      <FormInputStyled
        ref={ref}
        placeholder={placeholder}
        type={type}
        name={name}
        onChange={onChange}
        value={value}
        marginVertical={marginVertical}
        autoComplete={autoComplete}
        maxLength={maxLength}
        pattern={pattern}
        keyboardType={keyboardType}
        returnKeyType={returnKeyType}
      />
      {error && <FormInputError>{error}</FormInputError>}
    </FormInputLabelWrapperStyled>
  )
})

FormInput.propTypes = {
  placeholder: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  error: PropTypes.string,
  fullWidth: PropTypes.bool,
  marginVertical: PropTypes.bool
}

FormInput.defaultProps = {
  placeholder: '',
  label: '',
  type: 'text',
  name: 'input',
  onChange: () => { },
  value: '',
  error: '',
  fullWidth: false,
  marginVertical: false
}

export default FormInput